import React, { ReactNode, RefObject, memo } from 'react';

import './styles.scss';

interface IButtonLink {
  className?: string;
  disabled?: boolean;
  innerRef?: RefObject<HTMLButtonElement>;
  onClick?: () => void;
  children?: ReactNode;
}

const ButtonLink: React.FC<IButtonLink> = ({
  className,
  disabled,
  innerRef,
  children,
  onClick,
}) => {
  return (
    <button
      ref={innerRef}
      className={`link-btn ${className ?? ''} ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default memo(ButtonLink);
